<template>
  <a-drawer
:touch-action="'none'"
width="80%"
title="设置订单详情"
placement="right"
:closable="true"
:visible="visible"
    @close="onClose"
:body-style="{ padding: '5px', overflow: 'hidden' }">
    <div>
      <a-button type="primary" @click="handleSub">确认选择</a-button>
    </div>
    <!-- <defaultTable :tenantId="tenantId" @backTable="onClose" v-if="visible && tenantId"></defaultTable> -->
    <div class="order">
      <div class="order_l">
        <div class="order_l_t">订单信息</div>
        <div class="order_l_i" v-for="(item, index) in dataForm.foundation" :key="item.id">
          <div class="order_l_i_t">
            {{ item.name }}
          </div>
          <div v-if="item.id !== 1" class="order_l_i_t1">
            <a-radio-group v-model="item.require" button-style="solid" @change="handleBlur($event, 2, item)">
              <a-radio-button :value="true">必填</a-radio-button>
              <a-radio-button :value="false">不必填</a-radio-button>
            </a-radio-group>
          </div>
          <div class="order_l_i_t1" v-else></div>
          <div class="order_l_i_t1">
            <a-radio-group v-model="item.hide" button-style="solid" @change="handleBlur($event, 3)">
              <a-radio-button :value="true" v-if="!item.require">隐藏</a-radio-button>
              <a-radio-button :value="false">显示</a-radio-button>
            </a-radio-group>
          </div>
          <div class="order_l_i_t2" v-if="item.id == 1"></div>
          <div class="order_l_i_t2" v-else>
            <a-input-number :min="1" v-model="item.sort" placeholder="请输入排序" @blur="handleBlur($event, 1)" />
          </div>
        </div>
        <div class="order_l_t" style="margin-top: 20px">管道存档</div>
        <div class="order_l_i" v-for="(item, index) in dataForm.optionsType" :key="item.type + '+1'">
          <div class="order_l_i_t">
            {{ item.names }}
          </div>
          <div class="order_l_i_t1">
            <a-radio-group v-model="item.require" button-style="solid" @change="handleBlur($event, 5, item)">
              <a-radio-button :value="true">必填</a-radio-button>
              <a-radio-button :value="false">不必填</a-radio-button>
            </a-radio-group>
          </div>
          <div class="order_l_i_t1">
            <a-radio-group v-model="item.hide" button-style="solid" @change="handleBlur($event, 6)">
              <a-radio-button :value="true" v-if="!item.require">隐藏</a-radio-button>
              <a-radio-button :value="false">显示</a-radio-button>
            </a-radio-group>
          </div>
          <div class="order_l_i_t2">
            <a-input-number :min="1" v-model="item.sort" placeholder="请输入排序" @blur="handleBlur($event, 4)" />
          </div>
        </div>
      </div>
      <div class="order_r" @touchstart="passThrough" @touchmove="passThrough" style="touch-action: none">
        <!-- <iframe
          ref="uniIframe"
          src="http://192.168.1.9:8081/newShare/#/pages/order/drag"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-pointer-lock"
          style="width: 100%; height: 500px; pointer-events: auto"
          scrolling="no"
        /> -->
        <div class="order_u">
          <iframe ref="uniIframe" :src="$Preview + 'newShare/index.html#/pages/order/drag'"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-pointer-lock"
            scrolling="no"
style="pointer-events: auto"
class="iframe" />
        </div>
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { tableMixin } from '@/store/table-mixin'
// import defaultTable from './defaultTable'
import { getTenant, updateTenant } from '@/api/system/tenant'
export default {
  mixins: [tableMixin],
  name: 'Post',
  components: {},
  data() {
    return {
      visible: false,
      tenantId: '',
      deList: [],
      form: {},
      dataForm: {
        foundation: [
          {
            name: '档案编号',
            sort: 0,
            title: 'orderNo',
            require: false,
            hide: false,
            id: 1,
            height: '54px',
          },
          {
            name: '业主姓名',
            sort: 2,
            require: false,
            hide: false,
            title: 'ownerName',
            id: 2,
          },
          {
            name: '联系电话',
            sort: 3,
            title: 'ownerPhone',
            require: false,
            hide: false,
            id: 3,
          },
          {
            name: '水工姓名',
            sort: 4,
            title: 'waterName',
            require: false,
            hide: false,
            id: 4,
          },
          {
            name: '水工电话',
            sort: 5,
            title: 'waterPhone',
            require: false,
            hide: false,
            id: 5,
          },
          {
            name: '小区地址',
            title: 'area',
            require: false,
            hide: false,
            sort: 6,
            id: 6,
          },
          {
            name: '小区名称',
            height: '154px',
            title: 'minAreaName',
            hide: false,
            require: false,
            sort: 7,
            id: 7,
          },
          {
            name: '房屋面积',
            sort: 8,
            title: 'housingArea',
            require: false,
            hide: false,
            id: 8,
          },
          {
            name: '品牌',
            sort: 9,
            title: 'valveBrand',
            require: false,
            hide: false,
            id: 9,
          },
          {
            name: '装修公司',
            sort: 10,
            title: 'decorationCompany',
            require: false,
            hide: false,
            id: 10,
          },
          {
            name: '检查连接点',
            sort: 11,
            title: 'connectionCheck',
            require: false,
            hide: false,
            id: 11,
          },
          {
            name: '服务类型',
            sort: 12,
            title: 'serviceType',
            require: false,
            hide: false,
            id: 12,
          },
          {
            name: '业主是否在场',
            sort: 13,
            title: 'ownersPresent',
            require: false,
            hide: false,
            id: 13,
          },
          {
            name: '全套产品',
            sort: 14,
            title: 'completeProducts',
            require: false,
            hide: false,
            id: 14,
          },
          {
            name: '购买渠道',
            sort: 15,
            title: 'purchaseChannels',
            require: false,
            hide: false,
            id: 15,
          },
          {
            name: '装修方式',
            sort: 16,
            title: 'constructionSubjects',
            require: false,
            hide: false,
            id: 16,
          },
          {
            name: '装修情况',
            sort: 17,
            title: 'decorationSituation',
            require: false,
            hide: false,
            id: 17,
          },
          // {
          // 	name: '施工属性',
          // 	sort: 22,
          // 	title:'constructionAttributes',
          // 	id: 22,
          // },
          // {
          // 	name: '施工主体',
          // 	sort: 23,
          // 	title:'constructionSubject',
          // 	id: 23,
          // },
          {
            name: '房屋类型',
            sort: 18,
            title: 'houseType',
            require: false,
            hide: false,
            id: 18,
          },
          {
            name: '安装方式',
            sort: 19,
            title: 'installationMethods',
            require: false,
            hide: false,
            id: 19,
          },
          {
            name: '材料服务清单',
            sort: 20,
            title: 'fileManyFileParams',
            require: false,
            hide: false,
            id: 20,
          },
          {
            name: '施工空间数据',
            sort: 21,
            title: 'spatialData',
            require: false,
            hide: false,
            id: 21,
          },
          {
            name: '产品品类',
            sort: 22,
            title: 'categoryProduct',
            require: false,
            hide: false,
            id: 22,
          },
        ],
        optionsType: [
          {
            type: 15,
            name: ['形', '象', '照'],
            names: '形象照',
            filesType: [],
            sort: 1,
            files: [],
            hide: false,
            require: false,
          },
          {
            type: 1,
            name: ['试', '压', '仪', '图'],
            names: '试压仪图',
            files: [],
            sort: 2,
            filesType: [],
            hide: false,
            require: false,
          },
          {
            type: 2,
            name: ['门', '牌', '号'],
            names: '门牌号',
            filesType: [],
            hide: false,
            sort: 3,
            require: false,
            files: [],
          },
          {
            type: 3,
            name: ['走', '廊'],
            filesType: [],
            names: '走廊',
            hide: false,
            sort: 4,
            require: false,
            files: [],
          },
          {
            type: 4,
            name: ['客', '厅'],
            names: '客厅',
            filesType: [],
            sort: 5,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 5,
            name: ['主', '卧'],
            names: '主卧',
            filesType: [],
            sort: 6,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 6,
            name: ['次', '卧'],
            names: '次卧',
            filesType: [],
            hide: false,
            sort: 7,
            require: false,
            files: [],
          },
          {
            type: 7,
            name: ['厨', '房'],
            names: '厨房',
            filesType: [],
            sort: 8,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 8,
            name: ['主', '卫'],
            names: '主卫',
            filesType: [],
            sort: 9,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 9,
            name: ['次', '卫'],
            names: '次卫',
            filesType: [],
            sort: 10,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 10,
            name: ['阳', '台'],
            names: '阳台',
            filesType: [],
            sort: 11,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 11,
            name: ['温', '馨', '提', '示'],
            names: '温馨提示',
            hide: false,
            require: false,
            sort: 12,
            filesType: [],
            files: [],
          },
          {
            type: 14,
            name: ['其', '他'],
            names: '其他',
            hide: false,
            require: false,
            sort: 15,
            filesType: [],
            files: [],
          },
          {
            type: 13,
            name: ['品', '质', '凭', '证'],
            names: '品质凭证',
            filesType: [],
            sort: 13,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 103,
            name: '其他资料链接',
            names: '其他资料链接',
            filesType: [],
            sort: 14,
            hide: false,
            require: false,
            title: 'otherVrUrl',
            files: [],
          },
          {
            type: 100,
            name: '备注',
            names: '备注',
            filesType: [],
            sort: 14,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 101,
            name: '质保承诺',
            names: '质保承诺',
            sort: 15,
            hide: false,
            require: false,
          },
          {
            type: 102,
            name: '评价',
            names: '评价',
            sort: 16,
            hide: false,
            require: false,
          },
          {
            type: 104,
            name: '质保区分',
            names: '质保区分',
            sort: 15,
            hide: false,
            require: false,
          },
        ],
      },
    }
  },
  filters: {},
  created() {
    console.log(this.router, '111111222')
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    sendDataToIframe(data) {
      const iframe = this.$refs.uniIframe
      if (iframe && iframe.contentWindow) {
        console.log(data, 'datadata')
        iframe.contentWindow.postMessage(data, '*') // 第二个参数为目标origin，'*'表示不限制
      }
    },
    // 点击改变
    handleBlur(e, sort, item) {
      console.log(e, '顶顶顶顶eee')
      console.log(sort, '顶顶顶顶')
      console.log(item, 'itemitemitem')
      this.dataForm.type = sort
      // this.dataForm.foundation
      if (sort == 1) {
        this.dataForm.foundation.sort((a, b) => a.sort - b.sort)
      } else if (sort == 2 || sort == 5) {
        item.hide = false
      } else if (sort == 3) {
        const falseHideCount = this.dataForm.foundation.filter((item) => item.hide === false).length
        const str = falseHideCount * 54 + 'px'
        this.dataForm.str = str
        // const str = falseHideCount * 54 + 'px'
      } else if (sort == 4) {
        this.dataForm.optionsType.sort((a, b) => a.sort - b.sort)
      } else if (sort == 6) {
      }
      // if (sort == 2 && item.require) {
      //   item.hide = false
      // }
      const falseHideCount = this.dataForm.optionsType.filter((item) => item.hide === false).length
      const str = falseHideCount * 124 + 'px'
      this.dataForm.str1 = str
      setTimeout(() => {
        this.sendDataToIframe(this.dataForm)
        // console.log(this.dataForm, '的点点滴滴')
      }, 100)
    },
    handleSend() {
      console.log(1111)
      this.sendDataToIframe({ name: '1212' })
    },
    // 接收子页面消息
    handleIframeMessage(event) {
      if (event.origin !== 'http://192.168.0.106:8081') return // 安全校验
      console.log('收到子页面消息:', event.data)
      // 处理数据...
    },
    init(e, index) {
      console.log(e, index, 'sdd的点点滴滴')
      // this.tenantId = e.id
      getTenant(e.id).then((res) => {
        this.form = res.data
        if (res.data.htmlLayout) {
          // res.data.htmlLayout
          const htmlLayout = JSON.parse(res.data.htmlLayout)
          console.log(htmlLayout, 'htmlLayouthtmlLayout')
          // this.optionsType.forEach((v) => {
          //   htmlLayout.optionsType.forEach((item) => {
          //     if (item.type !== v.type) {
          //       item = v
          //     }
          //   })
          // })
          //  const has11 = htmlLayout.foundation.some((item) => item.id === 11)
          // const hasType103 = htmlLayout.optionsType.some((item) => item.type === 103)
          // console.log(hasType103, 'hasType103hasType103')
          // const hasType14 = htmlLayout.optionsType.some((item) => item.type === 14)
          // console.log(hasType14, 'hasType103hasType103')
          // const has11 = htmlLayout.foundation.findIndex((item) => item.id === 11)
          const has122 = htmlLayout.foundation.some((item) => item.id === 22)
          // const has123 = htmlLayout.foundation.some((item) => item.id === 23)
          // const has123 = htmlLayout.foundation.some((item) => item.id === 23)
          const hasType104 = htmlLayout.optionsType.some((item) => item.type === 104)
          const hasType16 = htmlLayout.optionsType.some((item) => item.type === 16)
          console.log(hasType16, 'hasType16hasType16hasType16')
          // htmlLayout.foundation.pop()
          if (!has122) {
            htmlLayout.foundation.push({
              name: '产品品类',
              sort: 22,
              title: 'categoryProduct',
              require: false,
              hide: false,
              id: 22,
            })
          }
          if (!hasType104) {
            htmlLayout.optionsType.push({
              type: 104,
              name: '质保区分',
              names: '质保区分',
              sort: 15,
              hide: false,
              require: false,
            })
          }
          // if (!hasType16) {
          //   htmlLayout.optionsType.push({
          //     type: 99,
          //     name: '其他全景',
          //     names: '其他全景',
          //     sort: 14,
          //     hide: false,
          //     require: false,
          //     filesType: [],
          //     files: [],
          //   })
          // }

          //  else {
          //   const index = htmlLayout.optionsType.findIndex((item) => item.type === 103)
          //   htmlLayout.optionsType[index].title = 'otherVrUrl'
          // }
          // console.log(hasType103, 'hasType103hasType103')

          // if (!hasType14) {
          //   htmlLayout.optionsType.push({
          //     type: 14,
          //     name: ['其', '他'],
          //     names: '其他',
          //     hide: false,
          //     require: false,
          //     sort: 15,
          //     filesType: [],
          //     files: [],
          //   })
          // }
          setTimeout(() => {
            this.dataForm = htmlLayout
            this.sendDataToIframe(this.dataForm)
          }, 0)
        } else {
          this.getSet()
        }
      })
      this.visible = true
    },
    getSet() {
      this.dataForm = {
        foundation: [
          {
            name: '档案编号',
            sort: 1,
            title: 'orderNo',
            require: false,
            hide: false,
            id: 1,
            height: '54px',
          },
          {
            name: '业主姓名',
            sort: 2,
            require: false,
            hide: false,
            title: 'ownerName',
            id: 2,
          },
          {
            name: '联系电话',
            sort: 3,
            title: 'ownerPhone',
            require: false,
            hide: false,
            id: 3,
          },
          {
            name: '水工姓名',
            sort: 4,
            title: 'waterName',
            require: false,
            hide: false,
            id: 4,
          },
          {
            name: '水工电话',
            sort: 5,
            title: 'waterPhone',
            require: false,
            hide: false,
            id: 5,
          },
          {
            name: '小区地址',
            title: 'ownerAddress',
            require: false,
            hide: false,
            sort: 6,
            id: 6,
          },
          {
            name: '小区名称',
            height: '154px',
            title: 'minAreaName',
            hide: false,
            require: false,
            sort: 7,
            id: 7,
          },
          {
            name: '房屋面积',
            sort: 8,
            title: 'housingArea',
            require: false,
            hide: false,
            id: 8,
          },
          {
            name: '品牌',
            sort: 9,
            title: 'valveBrand',
            require: false,
            hide: false,
            id: 9,
          },
          {
            name: '装修公司',
            sort: 10,
            title: 'decorationCompany',
            require: false,
            hide: false,
            id: 10,
          },
          {
            name: '检查连接点',
            sort: 11,
            title: 'connectionCheck',
            require: false,
            hide: false,
            id: 11,
          },
          {
            name: '服务类型',
            sort: 12,
            title: 'serviceType',
            require: false,
            hide: false,
            id: 12,
          },
          {
            name: '业主是否在场',
            sort: 13,
            title: 'ownersPresent',
            require: false,
            hide: false,
            id: 13,
          },
          {
            name: '全套产品',
            sort: 14,
            title: 'completeProducts',
            require: false,
            hide: false,
            id: 14,
          },
          {
            name: '购买渠道',
            sort: 15,
            title: 'purchaseChannels',
            require: false,
            hide: false,
            id: 15,
          },
          {
            name: '装修方式',
            sort: 16,
            title: 'constructionSubjects',
            require: false,
            hide: false,
            id: 16,
          },
          {
            name: '装修情况',
            sort: 17,
            title: 'decorationSituation',
            require: false,
            hide: false,
            id: 17,
          },
          // {
          // 	name: '施工属性',
          // 	sort: 22,
          // 	title:'constructionAttributes',
          // 	id: 22,
          // },
          // {
          // 	name: '施工主体',
          // 	sort: 23,
          // 	title:'constructionSubject',
          // 	id: 23,
          // },
          {
            name: '房屋类型',
            sort: 18,
            title: 'houseType',
            require: false,
            hide: false,
            id: 18,
          },
          {
            name: '产品品类',
            sort: 22,
            title: 'categoryProduct',
            require: false,
            hide: false,
            id: 22,
          },
          {
            name: '安装方式',
            sort: 19,
            title: 'installationMethods',
            require: false,
            hide: false,
            id: 19,
          },
          {
            name: '材料服务清单',
            sort: 20,
            title: 'fileManyFileParams',
            require: false,
            hide: false,
            id: 20,
          },
          {
            name: '施工空间数据',
            sort: 21,
            title: 'spatialData',
            require: false,
            hide: false,
            id: 21,
          },
          {
            name: '产品品类',
            sort: 22,
            title: 'categoryProduct',
            require: false,
            hide: false,
            id: 22,
          },
        ],
        optionsType: [
          {
            type: 15,
            name: ['形', '象', '照'],
            names: '形象照',
            filesType: [],
            sort: 1,
            files: [],
            hide: false,
            require: false,
          },
          {
            type: 1,
            name: ['试', '压', '仪', '图'],
            names: '试压仪图',
            files: [],
            sort: 2,
            filesType: [],
            hide: false,
            require: false,
          },
          {
            type: 2,
            name: ['门', '牌', '号'],
            names: '门牌号',
            filesType: [],
            hide: false,
            sort: 3,
            require: false,
            files: [],
          },
          {
            type: 3,
            name: ['走', '廊'],
            filesType: [],
            names: '走廊',
            hide: false,
            sort: 4,
            require: false,
            files: [],
          },
          {
            type: 4,
            name: ['客', '厅'],
            names: '客厅',
            filesType: [],
            sort: 5,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 5,
            name: ['主', '卧'],
            names: '主卧',
            filesType: [],
            sort: 6,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 6,
            name: ['次', '卧'],
            names: '次卧',
            filesType: [],
            hide: false,
            sort: 7,
            require: false,
            files: [],
          },
          {
            type: 7,
            name: ['厨', '房'],
            names: '厨房',
            filesType: [],
            sort: 8,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 8,
            name: ['主', '卫'],
            names: '主卫',
            filesType: [],
            sort: 9,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 9,
            name: ['次', '卫'],
            names: '次卫',
            filesType: [],
            sort: 10,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 10,
            name: ['阳', '台'],
            names: '阳台',
            filesType: [],
            sort: 11,
            hide: false,
            require: false,
            files: [],
          },
          {
            type: 11,
            name: ['温', '馨', '提', '示'],
            names: '温馨提示',
            hide: false,
            require: false,
            sort: 12,
            filesType: [],
            files: [],
          },
          {
            type: 14,
            name: ['其', '他'],
            names: '其他',
            hide: false,
            require: false,
            sort: 15,
            filesType: [],
            files: [],
          },
          {
            type: 13,
            name: ['品', '质', '凭', '证'],
            names: '品质凭证',
            filesType: [],
            sort: 13,
            hide: false,
            require: false,
            files: [],
          },

          {
            type: 103,
            name: '其他资料链接',
            names: '其他资料链接',
            filesType: [],
            sort: 14,
            hide: false,
            require: false,
            title: 'otherVrUrl',
            files: [],
          },
          {
            type: 100,
            name: '备注',
            names: '备注',
            filesType: [],
            sort: 14,
            hide: false,
            require: false,
            title: 'remark',
            files: [],
          },
          {
            type: 101,
            name: '质保承诺',
            names: '质保承诺',
            title: 'warrantyCommitment',
            sort: 15,
            hide: false,
            require: false,
          },
          {
            type: 102,
            name: '评价',
            names: '评价',
            title: 'ownerEvaluate',
            sort: 16,
            hide: false,
            require: false,
          },
          // {
          //   type: 99,
          //   name: '其他全景',
          //   names: '其他全景',
          //   sort: 14,
          //   hide: false,
          //   require: false,
          //   filesType: [],
          //   files: [],
          // },
          {
            type: 104,
            name: '质保区分',
            names: '质保区分',
            sort: 15,
            hide: false,
            require: false,
          },
        ],
      }
    },
    // 点击确定选择
    handleSub() {
      // console.log(this.form, 'formformform')
      console.log(this.dataForm, 'this.dataFormthis.dataForm')
      this.form.htmlLayout = JSON.stringify(this.dataForm)
      updateTenant(this.form).then((res) => {
        this.$message.success('修改成功', 3)
        // this.onClose()
      })
    },
    passThrough(e) {
      e.stopPropagation() // 允许事件穿透到 Uniapp
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage

      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.visible = false
          that.tenantId = ''
        },
        onCancel() { },
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      console.log(e, '顶顶顶顶')
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      console.log(postIds, 'postIdspostIds')
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
<style lang="less">
// .ant-descriptions-item {
//   width: 25%;
//   // background: red;
// }
// .ant-descriptions-item-label {
//   width: 100px;
//   // background: red;
//   text-align: left;
// }
.order {
  display: flex;

  .order_l {
    height: 88vh;
    width: 70%;
    overflow-y: auto;
    margin-right: 20px;

    .order_l_t {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .order_l_i {
      padding: 0 30px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;

      .order_l_i_t {
        width: 150px;
      }

      .order_l_i_t1 {
        width: 150px;
      }

      .order_l_i_t2 {
        text-align: right;
        width: 150px;
      }
    }
  }
}

/* 在 Ant Design Vue 的全局样式中 */
.ant-modal-body,
.ant-drawer-body {
  touch-action: none !important;
  /* 禁用浏览器默认手势 */
  overscroll-behavior: none !important;
  /* 阻止滚动连锁 */
}

/* Uniapp 内容容器 */
.uniapp-container {
  touch-action: pan-y !important;
  /* 允许垂直拖拽 */
  width: 100%;
  height: 100%;
}

/* 禁用Ant Design的默认手势 */
:deep(.ant-drawer-body) {
  touch-action: none;
  overscroll-behavior: none;
}

.order_r {
  width: 405px;
  height: 727px;
  background: url(~@/assets/images/shou.png) no-repeat;
  background-size: 100% 100%;
  border-radius: 16px;
  overflow: hidden;
  padding: 30px 17px 20px;
  box-sizing: border-box;

  .order_u {
    height: 100%;
    width: 100%;
    // padding-left: 10px;
    margin-left: 5px;
    box-sizing: border-box;
  }
}

/* 禁用所有Ant Design的默认触摸拦截 */
:deep(.ant-drawer-body) {
  touch-action: none !important;
  overscroll-behavior: none !important;
}

iframe {
  width: 100%;
  height: 100%;
  touch-action: manipulation !important;
  -webkit-overflow-scrolling: touch !important;
  pointer-events: auto !important;
  border-radius: 16px;
}

// /deep/.ant-tabs-tab {
//   border: none !important;
//   padding-top: 0 !important;
// }
/* 在 App.vue 或页面的样式 */
</style>
